import { Activity, Cast, CheckCircle } from "react-feather";
import { Badge, NavItem } from "reactstrap";
import { Completed, Href, InProcess, Pending } from "../../../Constant";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { ToDoProp } from "../../../Type/ToDoType";

export const WorkingTabs = () => {
  const { todoList } = useAppSelector((state) => state.todo);

  return (
    <>
      <NavItem>
        <a href={Href}>
          <span className="iconbg bg-light-success">
            <CheckCircle className="stroke-success" />
          </span>
          <span className="title ms-2">{Completed}</span>
          <Badge pill color="success" className="text-white">
            {todoList.filter((data: ToDoProp) => data.badge === "Done").length}
          </Badge>
        </a>
      </NavItem>
      <NavItem>
        <a href={Href}>
          <span className="iconbg bg-light-danger">
            <Cast className="stroke-danger" />
          </span>
          <span className="title ms-2">{Pending}</span>
          <Badge pill color="danger" className="text-white">
            {todoList.filter((data: ToDoProp) => data.badge === "Pending").length}
          </Badge>
        </a>
      </NavItem>
      <NavItem>
        <a href={Href}>
          <span className="iconbg bg-light-info">
            <Activity className="stroke-info" />
          </span>
          <span className="title ms-2">{InProcess}</span>
          <Badge pill color="primary" className="text-white">
            {todoList.filter((data: ToDoProp) => data.badge === "In Progress").length}
          </Badge>
        </a>
      </NavItem>
    </>
  );
};
